
import { Helmet } from "react-helmet";

interface ProPageSEOProps {
  title: string;
  description: string;
  canonicalUrl: string;
}

export const ProPageSEO = ({ title, description, canonicalUrl }: ProPageSEOProps) => {
  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "SoftwareApplication",
    "name": "NLocale Pro",
    "applicationCategory": "BusinessApplication",
    "operatingSystem": "Web",
    "description": description,
    "url": canonicalUrl,
    "offers": {
      "@type": "Offer",
      "price": "0",
      "priceCurrency": "EUR",
      "availability": "https://schema.org/ComingSoon"
    },
    "audience": {
      "@type": "Audience",
      "audienceType": "Restaurants, Hébergements, Bars, Événementiel, Activités & Loisirs"
    },
    "areaServed": {
      "@type": "State",
      "name": "Aisne",
      "address": {
        "@type": "PostalAddress",
        "addressRegion": "Hauts-de-France",
        "addressCountry": "FR"
      }
    }
  };

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:type" content="website" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="robots" content="index, follow" />
      <link rel="canonical" href={canonicalUrl} />
      <script type="application/ld+json">
        {JSON.stringify(jsonLd)}
      </script>
    </Helmet>
  );
};
